import { PaginationParams, Redirect } from '@arpeggi/shared'

export interface GetManyRedirectsParams extends Omit<PaginationParams<Redirect>, 'orderBy'> {}

export interface CreateRedirectDto {
  from: string
  to: string
}
